// 维修热线 / 本地支持 — 中国区使用 400 电话，APAC/Mexico 不露出不适用的中国热线。
// 路由：/m/hotline
import { Button, Card, Typography } from 'antd';
import { LeftOutlined, PhoneOutlined, CustomerServiceOutlined, MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRegion } from '../hooks/useRegion.js';

const CN_HOTLINE = '400-820-7768';

export default function Hotline() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const region = useRegion();
	const isCn = region === 'cn';

	return (
		<div style={{ background: '#f5f5f5', minHeight: '100vh' }}>
		<div style={{ maxWidth: 720, margin: '0 auto' }}>
			<div style={{
				display: 'flex', alignItems: 'center',
				padding: '12px 12px', background: '#fff',
				borderBottom: '1px solid #f0f0f0',
			}}>
				<Button type="text" shape="circle" icon={<LeftOutlined />} onClick={() => navigate(-1)} />
				<Typography.Text strong style={{ flex: 1, textAlign: 'center', fontSize: 17 }}>
					{t('mtab.profile.hotline')}
				</Typography.Text>
				<div style={{ width: 32 }} />
			</div>

			<div style={{ padding: 20 }}>
				<Card style={{ borderRadius: 8, textAlign: 'center' }} styles={{ body: { padding: '32px 20px' } }}>
					<CustomerServiceOutlined style={{ fontSize: 48, color: '#FFA940', marginBottom: 16 }} />
					<Typography.Title level={5} style={{ marginTop: 0 }}>
						{isCn ? t('mtab.profile.hotline_label') : t('hotline.local_label')}
					</Typography.Title>
					<Typography.Text style={{ fontSize: 18, fontWeight: 600, color: '#FF7043', display: 'block', margin: '12px 0 24px' }}>
						{isCn ? CN_HOTLINE : t('hotline.local_value')}
					</Typography.Text>
					<Typography.Paragraph type="secondary" style={{ maxWidth: 360, margin: '0 auto 24px' }}>
						{isCn ? t('hotline.cn_desc') : t('hotline.local_desc')}
					</Typography.Paragraph>
					<Button
						type="primary"
						size="large"
						icon={isCn ? <PhoneOutlined /> : <MessageOutlined />}
						href={isCn ? `tel:${CN_HOTLINE.replace(/-/g, '')}` : undefined}
						onClick={isCn ? undefined : () => navigate('/m/feedback')}
						style={{ borderRadius: 8, height: 44, padding: '0 32px' }}
					>
						{isCn ? t('mtab.profile.call') : t('hotline.feedback_action')}
					</Button>
				</Card>
			</div>
		</div>
		</div>
	);
}
